import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { storage } from '../firebase';

export const uploadFileToFirebase = async (file, pathPrefix = 'uploads') => {
    if (!file) return null;

    try {
        const storageRef = ref(storage, `${pathPrefix}/${Date.now()}_${file.name}`);
        await uploadBytes(storageRef, file);
        const downloadURL = await getDownloadURL(storageRef);

        return {
            id: `${pathPrefix}-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`,
            name: file.name,
            url: downloadURL,
            type: file.type,
            size: file.size,
            createdAt: new Date().toISOString()
        };
    } catch (error) {
        console.error('Error uploading file to Firebase:', error);
        throw error;
    }
};